import {getTodayStartTime, daysBetween} from 'shared/utils/dateTime';
import {calcDailyBudget} from 'core/DailyBudget';
import {createBudget, valueOf} from 'core/Budget';

export function redistributeBudget(
  state: CoreState,
  startingFrom: UnixTimeStamp = getTodayStartTime()
): CoreState {
  const {budget, history} = state;
  const amount = valueOf(budget);

  const daysCount = daysBetween(budget.finishDate, startingFrom);
  const newBudget = createBudget(amount, daysCount);
  const newDailyBudget = calcDailyBudget(newBudget, history);

  return {
    ...state,
    budget: newBudget,
    dailyBudget: newDailyBudget,
  };
}
